import { AbstractControl } from '@angular/forms';
import { distinctUntilChanged, startWith } from 'rxjs';

export const listenControlValue$ = (control: AbstractControl) =>
  control.valueChanges.pipe(startWith(control.value), distinctUntilChanged());
